export default __webpack_public_path__ + "static/media/grafema_amcc_07.780900b9.jpg";